import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, Data } from '@angular/router';

import { Session } from '@services/session';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';

import { IGuardData } from './guard-data.interface';

@Injectable()
export class DispatchDriverWorkflowGuard {
  constructor(
    private router: Router,
    private session: Session,
    private fgFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const data: Data = route.data;
    const { redirectTo }: IGuardData = data.dispatchDriverWorkflowGuard;

    if (this.session.isDispatchDriverWorkflowEnabled()) return true;
    this.router.navigate([redirectTo || '']);
    return false;
  }
}
